export const dashboardWidgetCardClassName =
  'gap-0 rounded-sm border-border-subtle py-0 shadow-none';

export const dashboardWidgetTitleClassName =
  'text-body font-normal text-foreground';

export const dashboardWidgetLinkClassName =
  'inline-flex shrink-0 items-center gap-1 font-label uppercase text-brand-primary hover:text-brand-primary-dark';
